var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDemandeContenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 160",
    style: {
      enableBackground: "new 0 0 160 160"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n\t.st1{fill:#808080;}\n\t.st2{fill:#404040;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:none;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Carr\\xE9",
    className: "st0",
    d: "M95.4,107.2H63.7c-3.7,0-6.8-3-6.8-6.8V63.6c0-3.7,3-6.8,6.8-6.8h31.7c3.7,0,6.8,3,6.8,6.8v36.8 C102.2,104.2,99.2,107.2,95.4,107.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,72.2v9.3c0,3.5-1.5,6.5-3.9,8.7c1.8-2.1,3-4.8,3-7.7c0-6.4-5.2-11.6-11.6-11.6c-3,0-5.7,1.1-7.7,2.9 c2.1-2.4,5.2-3.9,8.6-3.9h9.3C90.9,69.8,91.9,70.9,91.9,72.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,82.4c0,3-1.1,5.7-3,7.7c-2.1,1.8-4.8,2.9-7.7,2.9c-6.4,0-11.6-5.2-11.6-11.6c0-3,1.1-5.7,3-7.7 c2.1-1.8,4.8-2.9,7.7-2.9C85.8,70.8,91,76,91,82.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88,90.1c-2.1,2.4-5.2,3.9-8.6,3.9h-9.3c-1.3,0-2.3-1-2.3-2.3v-9.3c0-3.5,1.5-6.5,3.9-8.7 c-1.8,2.1-3,4.8-3,7.7c0,6.4,5.2,11.6,11.6,11.6C83.3,93,86,91.9,88,90.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M84.6,80.9l-6.3-3.6c-0.8-0.4-1.7,0.1-1.7,1v7.2c0,0.9,1,1.5,1.7,1l6.3-3.6C85.4,82.5,85.4,81.4,84.6,80.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Bulle",
    className: "st4",
    d: "M80,26.4c-13.7,0-26.2,5.1-35.7,13.6c-11,9.8-18,24.1-18,40.1v42.9c0,5.9,4.8,10.7,10.7,10.7H80 c15.9,0,30.1-6.9,39.9-17.9c8.5-9.5,13.7-22,13.7-35.8C133.6,50.4,109.6,26.4,80,26.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemandeContenu);
export default __webpack_public_path__ + "static/media/demande_contenu.5e0e31bacf7b4f831047ef49987834c7.svg";
export { ForwardRef as ReactComponent };